import { render, staticRenderFns } from "./RecipeSettings.vue?vue&type=template&id=62301828&"
import script from "./RecipeSettings.vue?vue&type=script&lang=js&"
export * from "./RecipeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports